<div style="overflow: hidden;">
	<form [formGroup]="form">
		<div class="form-group mb-3 row">
			<span class="col-lg-2">Alias:</span>
			<div class="col-lg-7">
				<input class="form-control" type="text" [formControl]="alias" />
			</div>
			<div class="col-lg-2" style="margin-left: 20px; margin-top: -2px;">
				<button [disabled]="!enableUpdate" pButton label="Update"
					icon="fa fa-edit" type="button" (click)="update()" title="Set port state on the device"></button>
			</div>
		</div>
		<div class="form-group mb-3 row">
			<span class="col-lg-2">Name:</span>
			<div class="col-lg-7">
				<input class="form-control" type="text" [value]="name" readonly />
			</div>
		</div>
		<div class="form-group mb-3 row">
			<span class="col-lg-2">Description:</span>
			<div class="col-lg-7">
				<input class="form-control" type="text" [value]="description" readonly />
			</div>
		</div>
		<div class="form-group mb-0 row">
			<div class="uv-row">
				<span class="col-lg-2">&nbsp;</span>
				<button [disabled]="!enableRefresh" type="button" pButton label="Refresh"
						icon="fa fa-refresh" (click)="refresh()" title="Get current port state from the device"></button>
			</div>
		</div>
	</form>
</div>
